/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPrivacyRequest} from '../api'

 export const useQueryGetPrivacyRequest = createReactQueryHook('getPrivacyRequest', getPrivacyRequest)
